import { useState, FormEvent } from "react";
import {
    Typography,
    Stack,
    Alert,
} from "@mui/material";
import {
    AuthBox,
    LeftContent,
    RightContent,
    StyledTextField,
    FlexRowBox
} from "./Authentication.styles";
import BonisoftLogo from "../../common/ui/BonisoftLogo";
import LanguageSwitcher from "../../common/ui/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import { doApiPost } from "../../api/Requests";
import AuthLayout from "./AuthLayout";
import { GeneralButton } from "../../common/ui/GeneralButton";

export function ResetPasswordScreen() {
    const [email, setEmail] = useState("");
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const { t } = useTranslation();

    const onResetPassword = async (event: FormEvent) => {
        event.preventDefault();
        setIsError(false);
        setIsSuccess(false);
        setIsLoading(true);

        const result = await doApiPost<any, never>(
            "/api/users/password_reset",
            { eMail: email },
            { handleUnauthenticated: false }
        );

        setIsLoading(false);
        if (result.success()) {
            setIsSuccess(true);
        } else {
            setIsError(true);
        }
    };

    return (
        <AuthLayout>
            <AuthBox component="form" onSubmit={onResetPassword}>
                <FlexRowBox>
                    <LeftContent>
                        <Stack spacing={2}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Typography variant="h5">
                                    {t("authentication.authSettings.resetPassword")}
                                </Typography>
                                <LanguageSwitcher />
                            </Stack>

                            {!isSuccess && (
                                <>
                                    <StyledTextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="E-Mail"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    {isError && (
                                        <Alert severity="error">
                                            {t("authentication.authSettings.passwordResetFailed")}
                                        </Alert>
                                    )}
                                    <GeneralButton
                                        type="submit"
                                        loading={isLoading}
                                    >
                                        {t("authentication.authSettings.resetPassword")}
                                    </GeneralButton>
                                </>
                            )}

                            {isSuccess && (
                                <Alert severity="success">
                                    <Typography>
                                        {t("authentication.authSettings.emailSent")}: <b>{email}</b>
                                    </Typography>
                                </Alert>
                            )}
                        </Stack>
                    </LeftContent>

                    <RightContent>
                        <BonisoftLogo imgRatio={30} />
                    </RightContent>
                </FlexRowBox>
            </AuthBox>
        </AuthLayout>
    );
}
